import React from "react";

const Footer = () => {
  return (
    <footer
      className="footer"
      style={{
        backgroundColor: "whitesmoke",
        height: 0,
      }}
    >
      <div className="content has-text-centered">
        <p>
          <strong>
            Dit betreft een demo applicatie, ontwikkeld door Innovation Gateway
            Nederland B.V.
          </strong>
        </p>
        <img
          src="https://bulma.io/images/made-with-bulma--dark.png"
          alt="bulma-logo"
          width="150px"
        />
      </div>
    </footer>
  );
};

export default Footer;
